module.exports = __webpack_public_path__ + "static/img/ball.503ffd5b.png";